/**
 * WR Beautiful — Quick-Add Card Button
 * Extracted from product-card snippet to avoid repeated inline scripts.
 * Translated strings read from data attributes on each button element.
 */
if (typeof wrQuickAdd === 'undefined') {
  window.wrQuickAdd = function(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var textAdd = btn.getAttribute('data-text-add') || 'Sepete Ekle';
    var textAdded = btn.getAttribute('data-text-added') || 'Eklendi';
    var textError = btn.getAttribute('data-text-error') || 'Hata';

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(response) {
      if (!response.ok) throw new Error(response.statusText);
      return response.json();
    })
    .then(function() {
      var textEl = btn.querySelector('.wr-quick-add-text');
      if (textEl) textEl.textContent = textAdded;
      btn.setAttribute('aria-busy', 'false');

      /* Update header cart count */
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) {
              el.removeAttribute('hidden');
              el.classList.add('is-bouncing');
              setTimeout(function() { el.classList.remove('is-bouncing'); }, 600);
            }
          });
          /* Dispatch event for cart drawer to listen to */
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        });

      /* Reset button text after 1.5s */
      setTimeout(function() {
        if (textEl) textEl.textContent = textAdd;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      var textEl = btn.querySelector('.wr-quick-add-text');
      if (textEl) textEl.textContent = textError;
      btn.setAttribute('aria-busy', 'false');
      setTimeout(function() {
        if (textEl) textEl.textContent = textAdd;
        btn.disabled = false;
      }, 2000);
    });
  };
}
